import type { Props } from '../definition'

const setNavigation = (hash: string) => {
	const nav = R.navigation
	if (nav) {
		const path = hash.split('#')[1] || '/'

		const params = new URLSearchParams(window.location.search)

		for (const scheme of nav.scheme) {
			const page = scheme.page

			if (scheme.path === path) {
				R.libs.just.set(R, ['navigation', 'page'], page)
				for (const param of scheme.params || []) {
					R.libs.just.set(R, ['navigation', 'params', param], params.get(param))
				}
			}
		}
	}
}

export const initNavigation = (p: Props) => {
	if (p.navigationScheme) {
		R.libs.just.set(R, ['navigation'], R.libs.valtio.proxy({}))
		R.libs.just.set(R, ['navigation', 'scheme'], p.navigationScheme)
		R.libs.just.set(R, ['navigation', 'params'], {})

		window.addEventListener('hashchange', () => setNavigation(location.hash), false)
		setNavigation(location.hash)
	}
}
